// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const gaPageView = (url: string, gaTrackingId: string): void => {
    // @ts-ignore
    window?.gtag('config', gaTrackingId, {
        page_path: url,
    });
};

type GTagEvent = {
    action: string;
    category: string;
    label: string;
    value: number;
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const gaEvent = ({ action, category, label, value }: GTagEvent): void => {
    window?.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};
